export default __webpack_public_path__ + "static/media/banner1.3fbca88c.jpg";